const a = () => ({
  genericTaggingEvent: (e, n) => {
    window.dataLayer.push({
      event: e,
      params: n
    });
  }
});
export {
  a as default
};
